import { createRouter, createWebHistory } from 'vue-router';

import HomeAr from '../components/BusinessCard.vue';

const arabicRoutes = [
  { 
    path: '/', 
    name: 'HomeAr', 
    component: HomeAr, 
    meta: { 
      title: 'Bassant Metwally', 
      canonical: '/', 
      description: 'Assistant CEO for Business Development' 
    }
  },
];

const routes = [
  ...arabicRoutes,
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'Default Title'; 

  let descriptionMetaTag = document.querySelector("meta[name='description']");
  if (!descriptionMetaTag) {
    descriptionMetaTag = document.createElement('meta');
    descriptionMetaTag.setAttribute('name', 'description');
    document.head.appendChild(descriptionMetaTag);
  }
  descriptionMetaTag.setAttribute('content', to.meta.description || 'Default description for the page.');

  const link = document.querySelector("link[rel='canonical']") || document.createElement('link');
  link.setAttribute('rel', 'canonical');
  link.setAttribute('href', to.meta.canonical);
  document.head.appendChild(link);

  next();
});

export default router;
